// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1652de19] .basic__label-row-item-content{-webkit-box-flex:0!important;-ms-flex:none!important;flex:none!important;width:calc(100% - 75px)!important}", ""]);
// Exports
module.exports = exports;
